import { render, staticRenderFns } from "./funcionalidades.vue?vue&type=template&id=4aab2ed0&scoped=true&"
import script from "./funcionalidades.vue?vue&type=script&lang=js&"
export * from "./funcionalidades.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/bootstrap.min.css?vue&type=style&index=0&id=4aab2ed0&scoped=true&lang=css&"
import style1 from "./funcionalidades.vue?vue&type=style&index=1&id=4aab2ed0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aab2ed0",
  null
  
)

export default component.exports